import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";

const POPULAR = ["Builder", "Electrician", "Gas Engineer", "Roofer", "Barber"];

export default function Footer() {
  return (
    <footer className="border-t border-zinc-200 bg-white mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <BrandLogo size="sm" />
            <span className="font-display text-lg font-bold">TradeFlow UK</span>
          </div>
          <p className="text-sm text-zinc-500 leading-relaxed">
            The directory for Britain&apos;s independent small businesses.
          </p>
          <p className="text-xs text-zinc-700 mt-3 font-medium" data-testid="footer-charity">
            10% of revenue donated to charity
          </p>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-sm uppercase tracking-wider">Popular</h4>
          <ul className="space-y-2 text-sm text-zinc-600">
            {POPULAR.map((c) => (
              <li key={c}><Link to={`/search?category=${encodeURIComponent(c)}`} className="hover:text-black">{c}s</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-sm uppercase tracking-wider">Businesses</h4>
          <ul className="space-y-2 text-sm text-zinc-600">
            <li><Link to="/register" className="hover:text-black" data-testid="footer-register">List your business</Link></li>
            <li><Link to="/login" className="hover:text-black">Sign in</Link></li>
            <li><Link to="/faq" className="hover:text-black" data-testid="footer-faq">FAQ</Link></li>
            <li data-testid="footer-ico" className="pt-2 text-xs leading-relaxed text-zinc-500">
              ICO reg. no.: <span className="font-mono font-medium text-zinc-700">
                {process.env.REACT_APP_ICO_REGISTRATION || "to follow"}
              </span>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-sm uppercase tracking-wider">Contact</h4>
          <ul className="space-y-2 text-sm text-zinc-600">
            <li><a href="tel:+443330906124" className="hover:text-black font-mono" data-testid="footer-phone">0333 090 6124</a></li>
            <li><a href="mailto:support@tradeflowwork.com" className="hover:text-black">support@tradeflowwork.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200 py-6 px-4 flex flex-col sm:flex-row items-center justify-center gap-2 text-center text-xs text-zinc-500">
        <span>© {new Date().getFullYear()} TradeFlow UK · Listings are provided by the businesses themselves.</span>
        <span className="hidden sm:inline text-zinc-300">·</span>
        <Link to="/admin/login" data-testid="footer-admin-login"
          className="font-mono uppercase tracking-widest text-[10px] text-zinc-600 hover:text-black underline decoration-dotted underline-offset-4">
          Admin sign in
        </Link>
      </div>
    </footer>
  );
}
